module.exports = __webpack_public_path__ + "static/media/mantras-active.7004270c.png";